export const CETUS_APP_ID = '101082';
export const OTD_APP_ID = '101076';
export const COSMOS_APP_ID = '100684';
export const ALPS_CETUS_APP_ID = '1100147';
export const FY_CETUS_APP_ID = '1100533';

export const ALPS_APM_ID = 754177071;
export const ALPS_APM_TOKEN = '1757c7963b314b73b6b089a6b5f77729';

export const FY_APM_ID = 1464445013;
export const FY_APM_TOKEN = '5c0be29aed594415b4c5d42d61b0a382';

export const ALPS_TRACKER_TEST_URL
  = 'https://sensors.nio.com/sa?project=alpstest';
export const ALPS_TRACKER_PROD_URL = 'https://sensors.nio.com/sa?project=alps';

export const FY_TRACKER_TEST_URL = 'https://sensors.nio.com/sa?project=fytest';
export const FY_TRACKER_PROD_URL = 'https://sensors.nio.com/sa?project=fy';

/** 是否在微信浏览器中 */
export const IS_WEAPP_H5 = navigator.userAgent.includes('miniProgram');
/** 是否在app中 */
export const IS_APP = navigator.userAgent.includes('lg _dsbridge');
/** 是否在ios app中 */
export const IS_APP_IOS = IS_APP && navigator.userAgent.includes('OS:iOS');
/** 是否在android app中 */
export const IS_APP_ANDROID
  = IS_APP && navigator.userAgent.includes('OS:Android');
/** 是否在鸿蒙 app中 */
export const IS_APP_HARMONY
  = IS_APP && navigator.userAgent.includes('OS:Harmony');

export enum ENV_TYPE {
  DEV = 'dev',
  TEST = 'test',
  STG = 'stg',
  PROD = 'prod',
}

/** 平台类型 */
export enum PLATFORM {
  WEAPP,
  H5,
  WEB,
  IOS,
  ANDROID,
  HARMONY,
}

/** 当前平台类型 */
export const CURRENT_PLATFORM = IS_WEAPP_H5
  ? PLATFORM.WEAPP
  : IS_APP_IOS
    ? PLATFORM.IOS
    : IS_APP_ANDROID
      ? PLATFORM.ANDROID
      : IS_APP_HARMONY
        ? PLATFORM.HARMONY
        : PLATFORM.H5;

/** 品牌类型 */
export enum BRAND_TYPE {
  NIO = 'nio',
  ONVO = 'alps',
  FY = 'fy',
}

/** 品牌NAME */
export const BRAND_NAME = {
  NIO: 'nio',
  ONVO: 'alps',
  FY: 'fy',
};

/** 品牌名称 */
export const BRAND_TYPE_NAME: Record<BRAND_TYPE, string> = {
  [BRAND_TYPE.NIO]: '蔚来',
  [BRAND_TYPE.ONVO]: '乐道',
  [BRAND_TYPE.FY]: '第三品牌',
};

/** 页面来源，由外部传入 */
export const PAGE_SOURCE = new URL(window.location.href).searchParams.get(
  'page_source'
);

/** 页面标题，由外部传入 */
export const PAGE_TITLE = new URL(window.location.href).searchParams.get(
  'title'
);

/**
 * 报错页面类型
 */
export enum ERROR_PAGE_TYPE {
  /** 通用报错code */
  ERROR = 1,
  /** 限流报错code */
  LIMIT_ERROR,
  /** 活动未开启code */
  ACTIVITY_ENABLED,
  /** 无数据 */
  EMPTY,
}

/** 报错页面通用信息  */
export const ERROR_PAGE_INFO: Record<ERROR_PAGE_TYPE, any> = {
  [ERROR_PAGE_TYPE.ERROR]: {
    tips: '系统开小差了，请稍后再试',
    subtitle: '请点击刷新按钮重试',
    icon: 'fail_default', // 对应horo上的空组件类型
    linkText: '刷新',
  },
  [ERROR_PAGE_TYPE.LIMIT_ERROR]: {
    tips: '当前访问人数过多，请稍后再试',
    icon: 'empty_loading', // 对应horo上的空组件类型
  },
  [ERROR_PAGE_TYPE.ACTIVITY_ENABLED]: {
    tips: '当前活动暂未开启，敬请期待',
    icon: 'empty_phone', // 对应horo上的空组件类型
  },
  [ERROR_PAGE_TYPE.EMPTY]: {
    tips: '当前车型暂无数据',
    icon: 'empty_default',
    linkText: '切换车型',
  },
};

export const SEO_BRAND: Record<BRAND_TYPE, any> = {
  [BRAND_TYPE.NIO]: {
    title: '详细配置表',
    titleMp: '详细配置表',
    description: '',
    keywords: '',
  },
  [BRAND_TYPE.ONVO]: {
    title: '参数配置表_价格单-ONVO乐道官网',
    titleMp: '乐道详细配置表',
    description:
      '乐道汽车官网为您提供乐道详细配置表，深入了解这款家庭智能电动中型SUV的强大性能与丰富配置，为您的购车决策提供全面参考。',
    keywords: '乐道汽车,参数配置表,家庭智能电动SUV,中型SUV',
  },
  [BRAND_TYPE.FY]: {
    title: '详细配置表',
    titleMp: '详细配置表',
    description: '',
    keywords: '详细配置表',
  },
};

export const SHARE_CHANNEL_MAP: Record<string, string> = {
  nio_friend: 'niofriend',
  wechat_friend: 'wechatfriend',
  wechat_circle: 'wechatcircle',
  sina_weibo: 'weibo',
};
